import {useQuery} from "react-query";
import {Client} from "../../../../autogenerate/api.generated.clients";

export const useCompressorVariableNames = function (frameId: string) {
    return useQuery(`${frameId}-chart-variables`, () => new Client().chart_GetChartVariables(frameId))
}